import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useLang } from "@/i18n";
import api, { errMsg } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { LanguageToggle } from "@/components/SiteNav";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("auth.resetDone"));
      navigate("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="reset-password-page">
      <div className="flex items-center justify-between px-4 sm:px-6 h-16 border-b border-border">
        <Link to="/" className="flex items-center" data-testid="reset-logo">
          <img src="/logo.png" alt="English Universe Stars" className="h-14 w-auto" />
        </Link>
        <LanguageToggle />
      </div>
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <Card className="w-full max-w-md border-border shadow-lg">
          <CardContent className="p-8">
            <h1 className="text-2xl sm:text-3xl font-serif font-bold" data-testid="reset-title">{t("auth.resetTitle")}</h1>
            <p className="mt-1.5 text-sm text-muted-foreground">{t("auth.resetSub")}</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="reset-password">{t("auth.newPassword")}</Label>
                <Input id="reset-password" name="new-password" type="password" autoComplete="new-password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
              </div>
              <Button type="submit" className="w-full" size="lg" disabled={busy || !token} data-testid="reset-submit-btn">
                {busy ? t("auth.sending") : t("auth.resetBtn")}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
